/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [""];
export { styles as styles };



// WEBPACK FOOTER //
// /build/client-cms/src/app/device-board/device-board.component.css.shim.ngstyle.js.pre-build-optimizer.js